import React, { createContext, PropsWithChildren } from "react";

type BreakPointIndices = {
  /**
   * number in page builder only in desktop view
   */
  desktop?: number;
  /**
   * number in page builder only in tablet view
   */
  tablet?: number;
  /**
   * number in page builder only in mobile view
   */
  mobile?: number;
  /**
   * this is the overall index including anything from mobile, tablet, or desktop.
   * It matches directly to order in Sanity
   */
  overall?: number;
};

export const ModuleContext = createContext<{
  indexInPageBuilder: BreakPointIndices;
  type: string;
}>({
  indexInPageBuilder: {
    desktop: 0,
    tablet: 0,
    mobile: 0,
    overall: 0,
  },
  type: "",
});

interface ProviderProps {
  indexInPageBuilder: BreakPointIndices;
  type: string;
}
export const ModuleContextProvider: React.FC<
  PropsWithChildren<ProviderProps>
> = ({ children, type, indexInPageBuilder }) => {
  return (
    <ModuleContext.Provider value={{ indexInPageBuilder, type }}>
      {children}
    </ModuleContext.Provider>
  );
};
